module.exports = __webpack_public_path__ + "img/education.36546f29.jpg";